import 'animate.css';
import { FC, HTMLAttributes, useState } from 'react';
import './DivAnimated.less';

export const XmDivAnimated: FC<HTMLAttributes<HTMLDivElement> & { disabled?: boolean }> = (props) => {
  const [classes, setClasses] = useState('');

  return (
    <div
      onClick={(event) => {
        if (props.disabled) return;
        setClasses('div-animated');
        if (props.onClick) props.onClick(event);
      }}
      className={classes}
      onAnimationEnd={() => setClasses('')}
    >
      {props.children}
    </div>
  );
};
